import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { IconModule } from "@lantern/app/common/utils/icon";
import { UserActionDirectivesModule } from "@lantern/app/common/utils/user-action-directives";

import { FlexBoxModule } from "../flex-box";
import { StepComponent } from "./step.component";
import { StepperComponent } from "./stepper.component";

@NgModule({
  imports: [
    CommonModule,
    IconModule,
    FlexBoxModule,
    UserActionDirectivesModule
  ],
  declarations: [StepComponent, StepperComponent],
  exports: [StepComponent, StepperComponent]
})
export class StepperComponentModule {}
